"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeStatus = changeStatus;
const getIdsForAction_1 = require("./getIdsForAction");
async function changeStatus(props, storage, status, selectedRowIds, filterData, sortColumnKey, sortColumnDesc) {
    const ids = await (0, getIdsForAction_1.getIdsForAction)(props, storage, selectedRowIds, filterData, sortColumnKey, sortColumnDesc);
    for (const id of ids) {
        await storage.post({
            action: 'partial-update',
            id: id,
            data: {
                status: status,
            },
        });
    }
}
